/**
 * @desc  String tool util class.
 *
 */

class StringTool {
  escapePolishCharacters(str) {
    str = str.replace('ą', 'a');
    str = str.replace('ć', 'c');
    str = str.replace('ę', 'e');
    str = str.replace('ł', 'l');
    str = str.replace('ń', 'n');
    str = str.replace('ś', 's');
    str = str.replace('ż', 'z');
    str = str.replace('ź', 'z');
    str = str.replace('ó', 'o');
    return str;
  }
}

export const stringTool = new StringTool();
